<template>
    <div component="Page_403" template="page">
        <div class="bg">
            <h1>403 Forbidden</h1>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Page_403',
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='Page_403'] {
    .bg {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    h1 {
        width: 100%;
        text-align: center;
    }
}
</style>
